import { shortenNumber } from 'common/utils/inputUtils'

const MoreOptions = ({ sum, displayed, className }: { sum: number; displayed: number; className?: string }) => (
  <div className={className}>{`+${shortenNumber(sum - displayed)}`}</div>
)

export default MoreOptions
